module.exports = __webpack_public_path__ + "static/media/antdlogo.b29324c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/antdlogo.svg
// module id = 823
// module chunks = 0